import { useState } from "react";

/**
 * Two feature boxes mirroring StreetEasy's listing page:
 *   - Home features  (unit-level; expanded by default)
 *   - Building features (building-level + policies; collapsed by default)
 *
 * Data comes from the /predict/sale response `property.home_features` and
 * `property.building_features` — each an array of {key, label}. Boxes hide
 * themselves when their list is empty.
 */
export default function PropertyFeatures({ property }) {
  const homeFeatures = property?.home_features || [];
  const buildingFeatures = property?.building_features || [];

  if (homeFeatures.length === 0 && buildingFeatures.length === 0) return null;

  return (
    <>
      {homeFeatures.length > 0 && (
        <FeatureBox
          title="Home Features"
          features={homeFeatures}
          defaultOpen={true}
        />
      )}
      {buildingFeatures.length > 0 && (
        <FeatureBox
          title="Building Features"
          features={buildingFeatures}
          defaultOpen={false}
        />
      )}
    </>
  );
}

function FeatureBox({ title, features, defaultOpen }) {
  const [open, setOpen] = useState(defaultOpen);

  const sectionStyle = {
    backgroundColor: "white",
    border: "none",
    borderRadius: "8px",
    padding: "24px",
    marginBottom: "24px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  };

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: open ? "2px solid #000" : "none",
    paddingBottom: open ? "8px" : 0,
    cursor: "pointer",
    userSelect: "none",
  };

  const headingStyle = {
    fontSize: "20px",
    fontWeight: "600",
    color: "#333",
    margin: 0,
  };

  return (
    <div style={sectionStyle}>
      <div style={headerStyle} onClick={() => setOpen((o) => !o)}>
        <h2 style={headingStyle}>
          {title}
          <span style={{ fontSize: "14px", fontWeight: "500", color: "#666", marginLeft: "8px" }}>
            ({features.length})
          </span>
        </h2>
        <span style={{ fontSize: "18px", color: "#666", transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>
          ▾
        </span>
      </div>

      {open && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
            gap: "8px 24px",
            marginTop: "16px",
          }}
        >
          {features.map((f) => (
            <div
              key={f.key}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "6px 0",
                borderBottom: "1px solid #eee",
                fontSize: "14px",
                color: "#333",
              }}
            >
              <span style={{ color: "#28a745", marginRight: "8px", fontWeight: "700" }}>✓</span>
              {f.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
